var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_32_16",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 32 \\u2013 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2450",
    "data-name": "\\uC0AC\\uAC01\\uD615 2450",
    width: 22.002,
    height: 22,
    transform: "translate(-2 -1)",
    fill: "none",
    stroke: "#b9bebe",
    strokeWidth: 1.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2451",
    "data-name": "\\uC0AC\\uAC01\\uD615 2451",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4014",
    "data-name": "\\uADF8\\uB8F9 4014",
    transform: "translate(2.999 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4012",
    "data-name": "\\uADF8\\uB8F9 4012",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2941",
    "data-name": "\\uD328\\uC2A4 2941",
    d: "M5.188,12.931C11.858,19.6,14.7,16.778,14.7,16.778l2.671-2.671-3.784-3.785L11.808,12.1a1.259,1.259,0,0,1-1.781,0L6.019,8.1a1.263,1.263,0,0,1,0-1.781L7.8,4.534,4.016.75,1.345,3.421S-1.483,6.261,5.188,12.931Z",
    transform: "translate(-0.06 0.939)",
    fill: "#fff",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTel);
export default __webpack_public_path__ + "static/media/icoTel.2597aea2d80b66fd9686c6c66c9a7aaa.svg";
export { ForwardRef as ReactComponent };